// hooks/useTheme.js
import { useState, useEffect } from 'react';
import colors from '../ColorConfig/colorconfig';

const useTheme = () => {
  const [theme, setTheme] = useState(colors);

  useEffect(() => {
    const handleThemeChange = () => {
      setTheme({...colors});
    };

    window.addEventListener('themeChanged', handleThemeChange);
    
    return () => {
      window.removeEventListener('themeChanged', handleThemeChange);
    };
  }, []);

  return theme;
};

export default useTheme;